import { Method } from 'axios';
import { Executable } from './executable';
import { WalletPass } from './interfaces';

/**
 * The input object to the GetWallet class constructor.
 */
export interface GetWalletInput {
  /**
   * The email of the wallet
   */
  email?: string;
  /**
   * The program ID the wallet belongs to.
   */
  programId?: number;
  /**
   * The brand ID the wallet belongs to.
   */
  brandId?: number;
  /**
   * The pass id of the wallet card.
   */
  passId?: number;
}

/**
 * Creates a product for the provided tenant to be able to generate and mint NFTs from.
 */
export class GetWallet extends Executable<WalletPass> {
  /**
   * getMethod is used by the BambuClient to properly construct the request call.
   * @returns request method
   */
  public getMethod(): Method {
    return 'get';
  }

  /**
   * getResponse is used by the BambuClient to propery return the response object type.
   * @param apiResponse the api response object returned by the BambuMeta client before being converted to the GetWalletResponse
   * @returns GetWalletResponse
   */
  public getResponse(apiResponse: any): WalletPass {
    return apiResponse;
  }

  /**
   * getURLPath is used by the BambuClient to properly construct the request call.
   * @param tenantId the tenant id defined in the BambuClient
   * @returns request url
   */
  public getURLPath(tenantId?: string): string {
    if (!this.brandId && this.passId) {
      return `${tenantId}/wallets/${this.passId}`;
    }
    if (!this.brandId) {
      throw new Error('brandId is required');
    } else if (this.passId) {
      return `${this.brandId}/wallets/${this.passId}`;
    } else if (this.programId && this.email) {
      return `${this.brandId}/programs/${this.programId}/wallets?email=${encodeURIComponent(
        this.email
      )}`;
    } else {
      throw new Error('passId or email and programId are required');
    }
  }

  /**
   * The pass id of the wallet card.
   */
  public passId?: number;

  /**
   * The program ID the wallet belongs to.
   */
  public programId?: number;

  /**
   * The brand ID the wallet belongs to.
   */
  public brandId?: number;

  /**
   * The email of the wallet
   */
  public email?: string;

  constructor(input?: GetWalletInput) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * Sets the email of the person
   * @param value The email of the person
   * @returns <GetWallet>
   */
  public setEmail(value: string): GetWallet {
    this.email = value;
    return this;
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): any {
    return undefined;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    if (this.brandId) {
      return 'brands';
    }
    return undefined;
  }
}
